const trustAsHtml = function ($sce) {
  return text => $sce.trustAsHtml(text);
};

trustAsHtml.$inject = ['$sce'];

export default trustAsHtml;
